






















import { Vue, Component, PropSync, Prop, Emit } from 'vue-property-decorator'

@Component
export default class HdsListItem extends Vue {
  @PropSync('selectedItems', { default: () => [] }) selectedItemsSync!: any[]
  @PropSync('item') itemSync!: any

  get isSelected() {
    return this.selectedItemsSync.find(i => i === this.itemSync)
  }

  get listItemClasses() {
    return {
      'hds-active': this.isSelected,
    }
  }

  @Prop({ type: Boolean, default: true }) ripple!: boolean

  @Emit('click')
  onClick(evt: Event) {
    return evt
  }
}
